import {handleActions} from 'redux-actions'
import * as ActionTypes from './actionTypes'
import {CLOSE_ALL_PANELS} from '../../../administration/userManagement/common/actionTypes'
import {TabKeys} from '../constants'

const initialState = {
    loading: false,
    loaded: true,
    updatingData: false,
    userId: null,
    selectedTab: TabKeys.ACCOUNT_SETTINGS,
    updatingWorkSchedule: false,
    errorBackup: null,
    isLastLicenseManagerOnDeleteAlertShown: false,
    isLastLicenseManagerOnDisableAtAlertShown: false,
    isLastLicenseManagerOnDisableApAlertShown: false,
}

export default handleActions({
    [ActionTypes.USER_PANEL_LOADING_SET]: (state, {payload: loading}) => ({...state, loading}),
    [ActionTypes.EDIT_USER_ID_SET]: (state, {payload: userId}) => ({...state, userId}),
    [ActionTypes.USER_PANEL_TAB_SET]: (state, {payload: tabKey}) => ({...state, selectedTab: tabKey}),
    [ActionTypes.USER_PANEL_STATE_SET]: (state, {payload: allState}) => ({...state, ...allState}),
    [ActionTypes.LOADED_SET]: (state, {payload: loaded}) => ({...state, loaded: loaded}),
    [ActionTypes.UPDATING_DATA_SET]: (state, {payload: updatingData}) => ({...state, updatingData}),
    [ActionTypes.UPDATING_WORK_SCHEDULE_SET]: (state, {payload: updatingWorkSchedule}) => ({...state, updatingWorkSchedule}),
    [ActionTypes.ERROR_BACKUP_UPDATE]: (state, {payload: errorBackup}) => ({...state, errorBackup}),
    [ActionTypes.LAST_LICENSE_MANAGER_ON_DELETE_ALERT_SHOWN_SET]: (state, {payload: isLastLicenseManagerOnDeleteAlertShown}) => ({
        ...state,
        isLastLicenseManagerOnDeleteAlertShown
    }),
    [ActionTypes.LAST_LICENSE_MANAGER_ON_DISABLE_AT_ALERT_SHOWN_SET]: (state, {payload: isLastLicenseManagerOnDisableAtAlertShown}) => ({
        ...state,
        isLastLicenseManagerOnDisableAtAlertShown
    }),
    [ActionTypes.LAST_LICENSE_MANAGER_ON_DISABLE_AP_ALERT_SHOWN_SET]: (state, {payload: isLastLicenseManagerOnDisableApAlertShown}) => ({
        ...state,
        isLastLicenseManagerOnDisableApAlertShown
    }),
    [CLOSE_ALL_PANELS]: (state) => ({
        ...state,
        loading: false,
        loaded: true,
        updatingData: false,
        userId: null,
        updatingWorkSchedule: false,
        errorBackup: null,
    }),
}, initialState)



// WEBPACK FOOTER //
// ./web/js/panels/user/editPanel/reducer.js